var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._b({staticClass:"field-choice"},'InputComponent',_vm.$attrs,false),[_c('ChoiceComponent',_vm._b({attrs:{"values":_vm.items},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'ChoiceComponent',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }